// Why Us data - value propositions for choosing NAIRDC
export const whyUsItems = [
  {
    title: "Recognized Excellence",
    imageKey: "awardWinning",
    info: "Our dedication to excellence and innovation has earned us prestigious industry awards. With a proven track record of delivering top-tier AI solutions, you can trust us to elevate your company to new heights.",
  },
  {
    title: "Empowering Bahraini Talent",
    imageKey: "bahrainIcon",
    info: "Our team consists of talented Bahraini professionals with exceptional expertise in AI. By harnessing the immense potential of local talent, we ensure that our solutions not only meet the highest standards but also resonate with the unique needs and culture of your company.",
  },
  {
    title: "Competitive Pricing",
    imageKey: "compCost",
    info: "We offer competitive pricing without compromising on the quality of our AI solutions. Rest assured, opting for our services means enjoying advanced AI technology at a price that aligns with your budget.",
  },
  {
    title: "Tailored Solutions for Optimal Outcomes",
    imageKey: "customization",
    info: "We firmly believe in customization for success. Through close collaboration with your team, we gain comprehensive insights into your business objectives, challenges, and desired outcomes. This enables us to customize our AI solutions to your specific requirements, ensuring optimal results and maximum impact for your company.",
  },
  {
    title: "Access to Tamkeen Financial Support",
    imageKey: "support",
    info: "As a strategic partner of Tamkeen, we facilitate access to their financial support programs for your company. This provides opportunities for grants, subsidies, and loans to fuel your AI initiatives, making cutting-edge technology more accessible and affordable than ever before.",
  },
];
